import { useEffect } from 'react';

const DEFAULT_TITLE = 'BeviAjuda';

export const useDocumentTitle = (title?: string | null) => {
  useEffect(() => {
    document.title = title ? `${title} – ${DEFAULT_TITLE}` : DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};
